import { useContext } from "react";
import { IconType } from "react-icons";
import {
  HiOutlineCurrencyDollar,
  HiOutlineIdentification,
  HiOutlineUserGroup,
} from "react-icons/hi";

import { ActionID } from "components/common/basic";
import { AuthContext } from "providers/Authentication";
import { useTranslation } from "translations";
import { RoutesByModule } from "utils";

interface LinkProps {
  actionId: ActionID;
  routeName: RoutesByModule["account"];
  Icon: IconType;
  label: string;
  helpText: string;
}

export default (): LinkProps[] => {
  const { session } = useContext(AuthContext);
  const { t } = useTranslation("account");

  if (!session) return [];

  const links: LinkProps[] = [
    {
      actionId: "accountSettings-go_to_orgInfo",
      routeName: "SETTINGS_INFO",
      Icon: HiOutlineIdentification,
      label: t("accountSettings_org.link.orgInfo.label", "Org info"),
      helpText: t(
        "accountSettings_org.link.orgInfo.helpText",
        "Provide personal details and how we can reach you"
      ),
    },
    {
      actionId: "accountSettings-go_to_team",
      routeName: "SETTINGS_TEAM",
      Icon: HiOutlineUserGroup,
      label: t("accountSettings_org.link.team.label", "Team"),
      helpText: t(
        "accountSettings_org.link.team.helpText",
        "Add internal staff, create teams, set roles and locations"
      ),
    },
    {
      actionId: "accountSettings-go_to_paymentSettings" as const,
      routeName: "SETTINGS_PAYOUT" as const,
      Icon: HiOutlineCurrencyDollar,
      label: t(
        "accountSettings_org.link.payoutSettings.label",
        "Invoicing service"
      ),
      helpText: t(
        "accountSettings_org.link.payoutSettings.helpText",
        "Set and adjust your payment settings for your organisation."
      ),
    },
  ];

  return links;
};
